export default "  .ftbDialog__footer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }";